import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Badge } from '../components/ui/Badge';

interface Alert { title: string; message: string; severity: string; }

export function Alerts() {
  const [list, setList] = useState<Alert[] | null>(null);
  const [error, setError] = useState('');

  async function load() {
    setError('');
    try { setList(await api<Alert[]>('/v1/alerts')); }
    catch { setError('Erreur de chargement.'); }
  }
  useEffect(() => { load(); }, []);

  return (
    <>
      <div className="pagehead">
        <h1>Alertes</h1>
        <div className="actions"><button className="small" onClick={load}>Actualiser</button></div>
      </div>
      {error && <div className="err">{error}</div>}
      {!list && !error && <div className="muted">Chargement...</div>}
      {list && list.length === 0 && <span className="muted">Aucune alerte ouverte.</span>}
      {list && list.map((a, idx) => (
        <div className="card" key={idx} style={{ marginBottom: 8 }}>
          <div className="row" style={{ justifyContent: 'space-between' }}>
            <strong>{a.title}</strong>
            <Badge kind={a.severity === 'critical' ? 'crit' : 'warn'}>{a.severity}</Badge>
          </div>
          <p className="muted" style={{ margin: '6px 0 0' }}>{a.message}</p>
        </div>
      ))}
    </>
  );
}
